/* short-lp-quiz.js */
(function () {
  'use strict';

  class ShortLPQuiz {
    constructor() {
      this.stepsEl = document.querySelector('[data-slq-steps]');
      if (!this.stepsEl) return;

      this.cards = Array.from(this.stepsEl.querySelectorAll('[data-slq-card]'));
      this.total = this.cards.length;
      this.progressFills = document.querySelectorAll('[data-slq-progress-fill]');
      this.progressTexts = document.querySelectorAll('[data-slq-progress-text]');
      this.ctaSection = document.querySelector('[data-slq-cta]');
      this.ctaBtn = document.querySelector('[data-slq-cta-btn]');
      this.ctaBtnText = document.querySelector('[data-slq-cta-btn-text]');
      this.ctaEyebrow = document.querySelector('[data-slq-cta-eyebrow]');
      this.ctaBody = document.querySelector('[data-slq-cta-body]');
      this.ctaHelper = document.querySelector('[data-slq-cta-helper]');

      this._jiggleTimer = null;
      this.bind();
    }

    bind() {
      // Watch data-state changes to trigger count-up on expand
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((m) => {
          if (m.attributeName === 'data-state' && m.target.dataset.state === 'expanded') {
            setTimeout(() => this.runCountUp(m.target), 180);
          }
        });
      });
      this.cards.forEach((card) => {
        observer.observe(card, { attributes: true, attributeFilter: ['data-state'] });
      });

      // Click on any locked card → start quiz
      this.cards.forEach((card) => {
        card.addEventListener('click', () => {
          if (card.dataset.state === 'locked') this.start();
        });
      });

      // "Got it – next step" buttons
      this.stepsEl.querySelectorAll('[data-slq-next]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const from = parseInt(btn.dataset.slqNext, 10); // 1-based step number
          this.advance(from);
        });
      });

      // "Show more / Show less" per-card toggle (post-unlock)
      this.stepsEl.querySelectorAll('[data-slq-show-more]').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const card = btn.closest('[data-slq-card]');
          const label = btn.querySelector('[data-slq-show-more-label]');
          const isOpen = card.hasAttribute('data-open');
          if (isOpen) {
            card.removeAttribute('data-open');
            btn.setAttribute('aria-expanded', 'false');
            if (label) label.textContent = 'Show more';
          } else {
            card.setAttribute('data-open', '');
            btn.setAttribute('aria-expanded', 'true');
            if (label) label.textContent = 'Show less';
            setTimeout(() => {
              card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }, 60);
          }
        });
      });

      // "Unlock" button on last card
      const unlockBtn = this.stepsEl.querySelector('[data-slq-unlock]');
      if (unlockBtn) {
        unlockBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.unlock();
        });
      }

      // Locked CTA → scroll to next actionable card + jiggle
      if (this.ctaBtn) {
        this.ctaBtn.addEventListener('click', (e) => {
          if (!this.ctaSection.hasAttribute('data-unlocked')) {
            e.preventDefault();
            this.stepsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
            clearTimeout(this._jiggleTimer);
            this._jiggleTimer = setTimeout(() => {
              this.cards.forEach((card) => {
                card.classList.add('slq-card--jiggle');
                card.addEventListener('animationend', (e) => {
                  if (e.animationName === 'slq-jiggle') card.classList.remove('slq-card--jiggle');
                }, { once: true });
              });
            }, 600);
          }
        });
      }

    }

    start() {
      clearTimeout(this._jiggleTimer);
      this.cards.forEach((c) => c.classList.remove('slq-card--jiggle'));
      // Show step 1 expanded, rest as preview
      this.cards.forEach((card, i) => {
        card.dataset.state = i === 0 ? 'expanded' : 'preview';
      });
      this.stepsEl.setAttribute('data-started', '');
      this.setProgress(1);
      this.stepsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    advance(fromStep) {
      clearTimeout(this._jiggleTimer);
      this.cards.forEach((c) => c.classList.remove('slq-card--jiggle'));
      // fromStep is 1-based → next card is index fromStep
      const nextIdx = fromStep;
      this.cards.forEach((card, i) => {
        if (i < nextIdx) card.dataset.state = 'completed';
        else if (i === nextIdx) card.dataset.state = 'expanded';
        else card.dataset.state = 'preview';
      });
      this.setProgress(nextIdx + 1);
      setTimeout(() => {
        this.cards[nextIdx].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 60);
    }

    unlock() {
      clearTimeout(this._jiggleTimer);
      this.cards.forEach((c) => c.classList.remove('slq-card--jiggle'));
      // All cards completed
      this.cards.forEach((card) => { card.dataset.state = 'completed'; });
      this.stepsEl.setAttribute('data-unlocked', '');
      this.setProgress(this.total);

      // Swap CTA content
      if (this.ctaSection) {
        this.ctaSection.setAttribute('data-unlocked', '');
      }
      if (this.ctaEyebrow) {
        this.ctaEyebrow.textContent = this.ctaEyebrow.dataset.unlockedText || '';
      }
      if (this.ctaBody) {
        this.ctaBody.textContent = this.ctaBody.dataset.unlockedText || '';
      }
      if (this.ctaBtn) {
        if (this.ctaBtnText) this.ctaBtnText.textContent = this.ctaBtn.dataset.unlockedText || '';
        const url = this.ctaBtn.dataset.unlockedUrl;
        if (url) this.ctaBtn.href = url;
      }
      if (this.ctaHelper) {
        const unlocked = this.ctaHelper.dataset.unlockedText;
        if (unlocked) this.ctaHelper.textContent = unlocked;
      }

      setTimeout(() => {
        this.ctaSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 600);
    }

    setProgress(count) {
      const pct = (count / this.total) * 100;
      this.progressFills.forEach((fill) => {
        fill.style.width = pct + '%';
        if (count > 0) fill.setAttribute('data-active', '');
      });
      this.progressTexts.forEach((text) => {
        text.textContent = count + ' / ' + this.total;
      });
    }

    runCountUp(card) {
      card.querySelectorAll('[data-count-up]').forEach((el) => {
        if (el.dataset.counted) return;
        el.dataset.counted = '1';
        const raw = el.dataset.countUp;
        const match = raw.match(/^(\d+(?:\.\d+)?)(.*)/);
        if (!match) return;
        const target = parseFloat(match[1]);
        const suffix = match[2];
        const duration = 1400;
        const start = performance.now();
        const tick = (now) => {
          const t = Math.min((now - start) / duration, 1);
          const eased = 1 - Math.pow(1 - t, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (t < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ShortLPQuiz());
  } else {
    new ShortLPQuiz();
  }
})();
